import { isEmpty } from 'lodash';
import * as yup from 'yup';
import { QuestionType } from '../utils/enums';

export function OneFormProjectVoteValidationSchema(props) {
	return yup.object().shape({
		consultationForms: yup
			.array()
			.of(ConsultationFormValidationSchema(props))
			.min(1, 'Ankieta/Sonda muszą zawierać przynajmniej jedną formę konsultacji')
	});
}

export const ConsultationFormValidationSchema = (props) => {
	return yup.object().shape({
		categories: yup.array().of(
			yup.object().shape({
				questions: yup.array().of(
					yup.object().shape({
						questionOptionCount: yup.number(),
						questionType: yup.number(),
						validationRegExp: yup.string().nullable(),
						validationErrorMessage: yup.string().nullable(),
						answerMaxLength: yup.number().nullable(),
						answers: yup
							.array()
							.when(
								[
									'questionType',
									'questionOptionCount',
									'validationRegExp',
									'validationErrorMessage',
									'answerMaxLength'
								],
								function(
									questionType,
									questionOptionCount,
									validationRegExp,
									validationErrorMessage,
									answerMaxLength
								) {
									return questionType !== QuestionType.Matrix
										? yup
												.array()
												.of(
													yup.object().shape({
														commnet: yup.string(),
														id: yup.number(),
														openText: yup.string()
													})
												)
												.min(1, 'Brak odpowiedzi na pytanie')
												.test(
													'regExpValidator',
													validationErrorMessage ? validationErrorMessage : '',
													function(value) {
														if (isEmpty(value)) {
															return true;
														}
														const currentAnswer =
															questionType === QuestionType.SingleText &&
															!!value[0].answerOptions.length
																? value[0].answerOptions[0].openText
																: questionType === QuestionType.SingleDate &&
																	!!value[0].answerOptions.length
																	? value[0].answerOptions[0].openDate
																	: questionType === QuestionType.SingleCheck &&
																		!!value[0].answerOptions.length
																		? value[0].answerOptions[0].questionOptionId
																		: null;

														if (validationRegExp && currentAnswer !== null) {
															const pattern = new RegExp(validationRegExp);
															return pattern.test(currentAnswer);
														}

														return true;
													}
												)
										: yup
												.array()
												.of(
													yup.object().shape({
														answerOptions: yup
															.array()
															.of(yup.object().shape({}))
															.min(
																questionOptionCount,
																'Brak odpowiedzi na wszystkie możliwe opcje'
															)
													})
												)
												.min(1, 'Brak odpowiedzi na wszystkie możliwe opcje');
								}
							),
						questionOptions: yup.array().when([ 'answers', 'questionType' ], (answers, questionType) => {
							const questionOptionId =
								answers && answers[0] && answers[0].answerOptions && answers[0].answerOptions[0]
									? answers[0].answerOptions[0].questionOptionId
									: -1;

							return questionType !== QuestionType.SingleRadio
								? yup.array()
								: yup.array().of(
										yup.object().shape({
											id: yup.number(),
											questions: yup.array().when([ 'id' ], (id) => {
												return id === questionOptionId
													? yup.array().of(
															yup.object().shape({
																questionOptionCount: yup.number(),
																questionType: yup.number(),
																answers: yup
																	.array()
																	.when(
																		[ 'questionType', 'questionOptionCount' ],
																		(questionType, questionOptionCount) => {
																			return questionType !== QuestionType.Matrix
																				? yup
																						.array()
																						.of(yup.object().shape({}))
																						.min(1, 'Brak odpowiedzi na pytanie')
																				: yup
																						.array()
																						.of(
																							yup.object().shape({
																								answerOptions: yup
																									.array()
																									.of(
																										yup.object().shape({})
																									)
																									.min(
																										questionOptionCount,
																										'Brak odpowiedzi na wszystkie możliwe opcje'
																									)
																							})
																						)
																						.min(
																							1,
																							'Brak odpowiedzi na wszystkie możliwe opcje'
																						);
																		}
																	)
															})
														)
													: yup.array();
											})
										})
									);
						})
					})
				)
			})
		)
	});
};

const QuestionsValidationSchema = yup.object().shape({
	questions: yup.array().of(
		yup.object().shape({
			questionOptionCount: yup.number(),
			questionType: yup.number(),
			answers: yup
				.array()
				.when([ 'questionType', 'questionOptionCount' ], (questionType, questionOptionCount) => {
					return questionType !== QuestionType.Matrix
						? yup.array().of(yup.object().shape({})).min(1, 'Brak odpowiedzi na pytanie')
						: yup
								.array()
								.of(
									yup.object().shape({
										answerOptions: yup
											.array()
											.of(yup.object().shape({}))
											.min(questionOptionCount, 'Brak odpowiedzi na wszystkie możliwe opcje')
									})
								)
								.min(1, 'Brak odpowiedzi na wszystkie możliwe opcje');
				})
		})
	)
});
